import { clear } from 'reducers/request';
import { useDispatch } from 'react-redux';
import { useEffect, useRef } from 'react';
import { always } from 'ramda';
import useFSPConfigRequestState from './useFSPConfigRequestState';

const EMPTY_REF = {
  resetForm: always,
  setSubmitting: always,
  values: [],
};

const useFormikInnerRef = (action, id) => {
  const [completed, failed] = useFSPConfigRequestState(action, id);
  const dispatch = useDispatch();
  const ref = useRef();

  useEffect(() => {
    const { resetForm, setSubmitting, values } = ref.current ?? EMPTY_REF;

    if (completed) {
      resetForm({ values });
      setSubmitting(false);
    }

    if (failed) {
      setSubmitting(false);
    }

    return () => {
      if (completed || failed) {
        dispatch(clear(action));
      }
    };
  }, [action, completed, dispatch, failed]);

  return ref;
};

export default useFormikInnerRef;
